import { css } from '@emotion/core'

export const partnershipSectionContainer = css`
  border: none;
  padding: 0;
  padding-left: 1.5rem;
`
